import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  UPDATE_COUPONS_LIST,
  CHANGE_COUPONS_FILTER,
  SHOW_COUPON_EDITOR_MODAL,
  CHANGE_COUPON_EDITOR_VALUES,
  SET_COUPON_EDITOR_ERROR_MESSAGE,
  SET_COUPON_EDITOR_LOADING,
  SHOW_COUPON_TOGGLE_CONFIRMATION,
  SET_COUPON_TOGGLE_LOADING,
  SHOW_COUPON_DETAILS_MODAL,
  SET_COUPON_DETAILS_LOADING,
  SET_COUPON_DETAILS_VALUES,
  SHOW_COUPON_DETAILS_ERROR_MESSAGE,
  SET_COUPON_DETAILS_LOGS,
  SET_COUPON_EDITOR_DIRTY,
  SET_COUPON_DETAILS_LOGS_LOADING,
  SET_COUPON_ASSIGN_MERCHANTS_MODAL_SHOWN,
  SET_COUPON_BUSINESS_ID_VALIDATION_RESULT,
} from 'state/actionTypes';

const couponsInitialState = {
  list: [],
  pageNumber: 1,
  pageSize: 10,
  totalCount: 2,
};

const coupons = createReducer(couponsInitialState, {
  [UPDATE_COUPONS_LIST]: (state, { payload: { list, paging } }) => ({
    ...state,
    list,
    pageNumber: paging.page,
    pageSize: paging.size,
    totalCount: paging.total,
  }),
});

const filterInitialState = {
  startDate: null,
  endDate: null,
  status: 'all',
  searchKeyword: '',
  statusOptions: [
    { key: 'all', value: 'all', text: 'ALL' },
    { key: 'on', value: 'on', text: 'Open' },
    { key: 'off', value: 'off', text: 'Suspended' },
    { key: 'ooq', value: 'ooq', text: 'Out of Quota' },
    { key: 'expired', value: 'expired', text: 'Expired' },
  ],
};

const filters = createReducer(filterInitialState, {
  [CHANGE_COUPONS_FILTER]: (state, { payload }) => ({
    ...state,
    ...payload,
    searchKeyword: payload.searchKeyword.toUpperCase(),
  }),
});

const editorModalShown = createReducer(false, {
  [SHOW_COUPON_EDITOR_MODAL]: (state, { payload }) => payload,
});

const editorInitialState = {};

const editorModalForm = createReducer(editorInitialState, {
  [CHANGE_COUPON_EDITOR_VALUES]: (state, { payload }) => payload,
});

const editorModalFormDirty = createReducer(false, {
  [SET_COUPON_EDITOR_DIRTY]: (state, { payload }) => payload,
});

const editorModalErrorInitialState = {
  message: [],
};

const editorModalError = createReducer(editorModalErrorInitialState, {
  [SET_COUPON_EDITOR_ERROR_MESSAGE]: (state, { payload }) => ({
    ...state,
    message: payload,
  }),
});

const editorModalLoading = createReducer(false, {
  [SET_COUPON_EDITOR_LOADING]: (state, { payload }) => payload,
});

const couponToggleConfirmationInitialState = {
  shown: false,
  couponCode: null,
  action: null,
  isLoading: false,
};
const couponToggleConfirmation = createReducer(
  couponToggleConfirmationInitialState,
  {
    [SHOW_COUPON_TOGGLE_CONFIRMATION]: (
      state,
      { payload: { shown, couponCode, action } }
    ) => ({
      ...state,
      couponCode,
      shown,
      action,
    }),
    [SET_COUPON_TOGGLE_LOADING]: (state, { payload }) => ({
      ...state,
      isLoading: payload,
    }),
  }
);

const couponDetailsModalInitialState = {
  shown: false,
  coupon: null,
  logs: {
    list: [],
    pageNumber: 1,
    pageSize: 10,
    totalCount: 0,
  },
  isLoading: false,
  isLogsLoading: false,
  errorShown: false,
  errorMessage: null,
};

const couponDetailsModal = createReducer(couponDetailsModalInitialState, {
  [SHOW_COUPON_DETAILS_MODAL]: (state, { payload: shown }) => ({
    ...state,
    shown,
  }),
  [SET_COUPON_DETAILS_LOADING]: (state, { payload: isLoading }) => ({
    ...state,
    isLoading,
  }),
  [SET_COUPON_DETAILS_VALUES]: (state, { payload: coupon }) => ({
    ...state,
    coupon,
  }),
  [SHOW_COUPON_DETAILS_ERROR_MESSAGE]: (
    state,
    { payload: { shown, message } }
  ) => ({
    ...state,
    errorShown: shown,
    errorMessage: message,
  }),
  [SET_COUPON_DETAILS_LOGS]: (state, { payload }) => ({
    ...state,
    logs: payload,
  }),
  [SET_COUPON_DETAILS_LOGS_LOADING]: (state, { payload }) => ({
    ...state,
    isLogsLoading: payload,
  }),
});

const assignMerchantsModalShown = createReducer(false, {
  [SET_COUPON_ASSIGN_MERCHANTS_MODAL_SHOWN]: (state, { payload }) => payload,
});

const businessIdValidationResult = createReducer(null, {
  [SET_COUPON_BUSINESS_ID_VALIDATION_RESULT]: (state, { payload }) => payload,
});

export default combineReducers({
  coupons,
  filters,
  editorModalShown,
  editorModalForm,
  editorModalFormDirty,
  editorModalError,
  editorModalLoading,
  couponToggleConfirmation,
  couponDetailsModal,
  assignMerchantsModalShown,
  businessIdValidationResult,
});
